
const SERVICE_BASE_URLS = {
  auth: process.env.REACT_APP_AUTH_SERVICE_URL,
  employee: process.env.REACT_APP_EMPLOYEE_SERVICE_URL,
  common: process.env.REACT_APP_BASE_URL,
  base: process.env.REACT_APP_BASE_URL,
  shift: process.env.REACT_APP_SHIFT_MANAGE_URL,
  payroll: process.env.REACT_APP_PAYROLL_SERVICE,
  notifications: process.env.REACT_APP_NOTIFICATIONS_SERVICE,
  notificationSocket: process.env.REACT_APP_NOTIFICATIONS_SOCKET,
  dsApis:process.env.REACT_APP_BASE_URL_DS
};

export default SERVICE_BASE_URLS;
